import { useSrpContext } from '@/src/contexts'
import { Box } from '@mui/material'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { useLocale, useTranslations } from 'next-intl'

export default function FlightScheduleBreadcrumbs() {
    const {
        SEOSrpData: { searchQuery }
    } = useSrpContext()
    const { origin, destination } = searchQuery || {}
    const locale = useLocale()
    const t = useTranslations('common')
    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" href={`/${locale}`}>
            {t('home')}
        </Link>,
        <Link underline="hover" key="2" color="inherit" href={`/${locale}/flights`}>
            {t('flights')}
        </Link>,
        <Typography key="3" sx={{ color: 'text.primary' }}>
            {t('originToDestinationFlights', { origin: origin || '', destination: destination || '' })}
        </Typography>
    ]

    return (
        <Box>
            <Breadcrumbs separator="›" aria-label="breadcrumb">
                {breadcrumbs}
            </Breadcrumbs>
        </Box>
    )
}

export { FlightScheduleBreadcrumbs }
